var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsInRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13V8a1 1 0 112 0v2.586l5.293-5.294a1 1 0 111.415 1.415L21.414 12H24a1 1 0 110 2h-5a1 1 0 01-1-1zm-5 5H8a1 1 0 100 2h2.586l-5.293 5.292a1 1 0 101.415 1.415L12 21.413V24a1 1 0 102 0v-5a1 1 0 00-1-1zm8.414 2H24a1 1 0 000-2h-5a1 1 0 00-1 1v5a1 1 0 102 0v-2.587l5.293 5.294a1 1 0 001.415-1.415L21.414 20zM13 7a1 1 0 00-1 1v2.586L6.708 5.292a1 1 0 10-1.415 1.415L10.586 12H8a1 1 0 100 2h5a1 1 0 001-1V8a1 1 0 00-1-1z"
  })));
}
export default SvgArrowsInRegular;